/* eslint-disable no-use-before-define */
import clsx from 'clsx';
import { debounce } from 'lodash';
import { FC, useEffect, useRef } from 'react';
import { useStyles } from './style';

let typeTimeout: any;

interface ITextArea {
  onChange: (e: any) => void;
  name: string;
  value: any;
  placeholder?: string;
  notBorder?: boolean;
  largeTextField?: boolean;
  litleTextField?: boolean;
  veryLitleTextField?: boolean;
  readOnly?: boolean;
  editArea?: boolean;
  numberLine?: number;
}

const TextArea: FC<ITextArea> = ({
  onChange,
  name,
  value,
  placeholder,
  notBorder,
  largeTextField,
  litleTextField,
  veryLitleTextField,
  readOnly,
  editArea,
  numberLine,
}) => {
  const classes = useStyles();
  const lineText = 22;
  const textRef = useRef(null);
  const updateValue = debounce(val => {
    onChange({
      target: {
        name: name as any,
        value: val,
      } as any,
    });
  }, 1000);

  const onKeyDown = (event: any) => {
    if (readOnly) return;
    updateValue(event.target.value);
  };

  const handleChange = (e: any) => {
    if (readOnly) return;
    updateValue(e.target.value);
  };

  const handleChangeGlobalState = (e: any) => {
    if (readOnly) return;
    onChange({
      target: {
        name: name as any,
        value: e.target.value,
      } as any,
    });
  };
  useEffect(() => {
    if (editArea && readOnly && textRef.current) {
      const textArea: any = textRef.current;
      textArea.value = '';
    }
  }, [readOnly, editArea]);

  return (
    <textarea
      ref={textRef}
      name={name || ''}
      onChange={handleChange}
      onKeyDown={onKeyDown}
      onBlur={handleChangeGlobalState}
      defaultValue={value}
      placeholder={placeholder || 'Aa'}
      readOnly={readOnly}
      className={clsx({
        [classes.textArea]: true,
        [classes.textAreaNotBorder]: notBorder,
        [classes.largeTextField]: largeTextField,
        [classes.litleTextField]: litleTextField,
        [classes.veryLitleTextField]: veryLitleTextField,
        [classes.editArea]: editArea,
      })}
      style={{
        ...(editArea && numberLine ? { height: lineText * numberLine } : {}),
        ...(editArea ? { fontWeight: 600 } : {}),
      }}
    />
  );
};

export default TextArea;
